import { LinkItem } from "@app/shared/models/link-item.interface";

export const footerImages: string[] = [
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-1.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-10.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-11.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-12.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-13.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-14.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-15.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-2.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-3.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-4.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-5.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-6.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-7.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-8.jpg',
    'https://cdn.xrossoversports.com/instagram/Instagram+scroll-9.jpg'
];

export const servicesLinks: LinkItem[] = [
    { title: 'About XrossOver', route: '/about', icon: '' },
    { title: 'The Vest', route: '/the-vest', icon: '' },
    { title: 'Download Our App', route: '/download-our-app', icon: '' },
    { title: 'FAQs', route: '/frequently-asked-questions', icon: '' },
    { title: 'Coaching', route: '/coaching', icon: '' },
    { title: 'Validate Vest', route: '/store/vests', icon: '' },
];

export const companyLinks: LinkItem[] = [
    { title: 'Coaching', route: '/coaching', icon: '' },
    { title: 'About Us', route: '/about', icon: '' },
    { title: 'Shop Now', route: '/store', icon: '' },
    { title: 'Contact', route: '/contact', icon: '' },
    { title: 'Blog', route: '/blog', icon: '' },
    { title: 'Unsubscribe Newsletter', route: '/unsubscribe-newsletter', icon: '' },
];

export const getInTouchLinks: LinkItem[] = [
    { title: '', route: 'https://www.facebook.com/profile.php?id=61563550592422&mibextid=LQQJ4d', icon: 'brand-facebook' },
    { title: '', route: 'https://www.tiktok.com/@xrossoversports?_t=8rbkqSZWADX&_r=1', icon: 'brand-tiktok' },
    { title: '', route: 'https://www.linkedin.com/company/xrossover-sports/', icon: 'brand-linkedin' },
    { title: '', route: 'https://www.instagram.com/xrossoversports?igsh=MW93d293emRrd2h1Yg%3D%3D&utm_source=qr', icon: 'brand-instagram' },
    { title: '', route: 'https://www.youtube.com/@XrossoverSports', icon: 'brand-youtube' },
];

export const legalLinks: LinkItem[] = [
    { title: 'Disclaimer and Safety Notice', route: '/disclaimer-safety-notice', icon: '' },
    { title: 'California Privacy Notice', route: '/privacy-notice', icon: '' },
    { title: 'Privacy Policy', route: '/privacy-policy', icon: '' },
    { title: 'Terms of Service', route: '/terms-and-conditions', icon: '' },
    { title: 'Cookies Settings', route: '/cookies-settings', icon: '' },
    { title: 'Shipping Policy', route: '/shipping-policy', icon: '' },
    { title: 'Refund Policy', route: '/refund-policy', icon: '' },
    { title: 'Refund Request', route: '/refund-request', icon: '' },
];